<template>
  <div v-if="isLoaded">
    <div v-if="orderHistoryData && userStore.user.isAdmin">
      <admin-order-history :order_history="orderHistoryData.order_history" />
    </div>
    <div v-else>
      <order-history :order_history="orderHistoryData.order_history" />
    </div>
  </div>
</template>
<script>
import { useReportStore } from "../stores/ReportStore.js";
import { useUserStore } from "../stores/UserStore.js";
import { ref, reactive } from "vue";
export default {
  name: "OrderHistoriesComponent",
  setup() {
    const orderHistoryData = reactive(),
      isLoaded = ref(false);
    return {
      orderHistoryData,
      isLoaded,
      userStore: useUserStore(),
    };
  },
  watch: {
    async orderHistoryData(value) {
      (this.isLoaded = true), (this.orderHistoryData = value);
    },
  },
  mounted() {
    this.getOrderHistory();
  },
  methods: {
    getOrderHistory() {
      this.isLoaded = false;
      const route = this.$router.resolve({
        name: "order-history",
      });
      console.log(route.href);
      axios
        .get(route.href)
        .then((response) => {
          if (response.data.error == true) {
            toastr.error(response.data.message, "Error!");
            return;
          }
          this.isLoaded = true;
          this.orderHistoryData = response.data.data;
        })
        .catch(function (error) {
          toastr.error(error.message, "Error!");
        });
    },
  },
};
</script>
